import React, { ReactNode, forwardRef } from 'react';
import styles from './extended-text-fields.module.scss';
import cn from 'classnames';
import { TextFieldProps } from '../main';
import { getBaseCompByType } from './helpers';

export type IconProps = {
  leftIcon?: ReactNode;
};

export type TextFieldWithIconProps = TextFieldProps & IconProps;

export const TextFieldWithIcon = forwardRef<
  HTMLInputElement,
  TextFieldWithIconProps
>(
  (
    {
      leftIcon,
      children,
      colorVariant = 'grey',
      disabled,
      className,
      type = 'text',
      ...textFieldProps
    },
    ref,
  ) => {
    const InputComponent = getBaseCompByType(type);

    return (
      <InputComponent
        {...textFieldProps}
        disabled={disabled}
        colorVariant={colorVariant}
        ref={ref}
        flexedStyle={false}
        className={cn(styles.inputWithIcon, className)}
        type={type}
      >
        <i
          tabIndex={0}
          className={cn(
            styles.icon,
            styles.leftIcon,
            styles[colorVariant],
            disabled && styles.disabled,
          )}
        >
          {leftIcon}
        </i>
        {children}
      </InputComponent>
    );
  },
);
